(() => {
  class ReelBorderFire extends PIXI.Container {
    constructor() {
      super();

      this._currentColour = gameController.COLOR_TYPES.normal;
      this._currentHue = 0;
    }

    initialise() {
      this._reelFrame = resourceManager.get("slotContainer:reelFrame");

      this._colourFilter = new PIXI.filters.ColorMatrixFilter();
      this._reelFrame.filters = [this._colourFilter];
    }

    /**
     * Switch to a specific colour
     */
    switchColour(colourToSwitchTo = gameController.COLOR_TYPES.normal, fadeOutDuration = 0.3) {
      if (colourToSwitchTo !== this._currentColour) {
        if (colourToSwitchTo !== gameController.COLOR_TYPES.normal) {
          soundManager.play("devilLaugh3");
        }

        this._currentColour = colourToSwitchTo;

        const obj = {
          amount: this._currentHue,
        };

        gsap.to(obj, {
          duration: fadeOutDuration,
          amount: colourToSwitchTo.frame,
          onUpdate: () => {
            this._colourFilter.hue(obj.amount, false);
            this._currentHue = obj.amount;
          },
        });
      }
    }
  }

  resourceManager.registerObjectType(
    "reelBorderFire",
    () => new ReelBorderFire(),
    () => {},
    () => []
  );
})();
